import React, { Component } from 'react';
import { Form, Button, Input, Modal, InputNumber } from 'antd';

export default function AddResource({ open, onCancel, onOk, type }) {
    const form = Form.useForm();

    const HandleOnFinish = data => {
        onOk(data);
    };

    return (
        <>
            <Modal open={open} onCancel={onCancel} onOk={onOk} footer={null}>
                <Form onFinish={HandleOnFinish}>
                    <Form.Item
                        label={`${type} Name`}
                        name={`name`}
                        id={`${type}Name`}
                        rules={[
                            {
                                type: 'string',
                                required: true,
                                message: `${type} Name is Required.`,
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item label="Capacity" name="capacity" id="capacity">
                        <InputNumber />
                    </Form.Item>
                    <Form.Item>
                        <Button block type="primary" htmlType="submit" hidden={true}>
                            {`Add ${type}`}
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
}
